import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DarkLightIcon from "../icons-svg/DarkLightIcon";
import { themeMode, toggleMode } from "../features/theme/themeSlice";

const DarkLightMode = () => {
  const { mode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();

  useEffect(() => {
    document.documentElement.className = mode;
    localStorage.setItem("thememode", mode);
  }, [mode]);

  return null;
};

export default DarkLightMode;
